import { useClockEffect } from '../state/timeState';
import { useViewportSizeUpdaterEffect } from '../utils';
export function GlobalEffects() {
    useViewportSizeUpdaterEffect();
    useClockEffect();
    return null;
}
